import { Grid } from '@mui/material';
import React from 'react';
// import PropTypes from 'prop-types';
//import { makeStyles } from '@material-ui/core/styles';
// import LoadingScreen from '../components/Complements/LoadingScreen';
//import PrincipalPanel from '../components/Logout/PrincipalPanel';
//import Login from '../components/Logout/PrincipalPanel';
//import { backgroundStyles } from '../styles/LoginTheme';
//import { Grid } from '@material-ui/core';
// import { isMobile } from 'react-device-detect';
/* import { isMobile } from 'react-device-detect';
import { history } from '../helpers/history';
import { sendMobile } from './../functions/mobile'; */

/* const useStyles = makeStyles(theme => ({
    fondo: {
      //fontFamily: 'MyriadPro-Bold',
      fontSize: '100%',
        [theme.breakpoints.up('xs')]: {
            backgroundColor: "#EEEFF2",
            width : "100%",
            height : "100%"
        },
        [theme.breakpoints.up('sm')]: {
            backgroundColor: "#EEEFF2",
            width : "100%",
            height : "100%"
        },
        [theme.breakpoints.up('md')]: {
            backgroundColor: "#EEEFF2",
            width : "100%",
            height : "100%"
        },
        [theme.breakpoints.up('lg')]: {
            backgroundColor: "#EEEFF2",
            width : "100%",
            height : "100%"
        },
        [theme.breakpoints.up('xl')]: {
            backgroundColor: "#EEEFF2",
            width : "100%",
            height : "100%"
        },
        
    },
    
})) */


const MaintenanceContainer = props => {
    // const [ loading, setLoading ] = useState(false);
    // const classes = backgroundStyles();

    return (
        <Grid container columns={{ sm: 6, md: 12 }} style={{ height: "100vh" }} >
            <Grid xs={12} sm={12} md={6} lg={6} style={{ flex: 1 }}>
                <Grid container justifyContent='center' alignItems='center' style={{ height: "100%", backgroundColor: "#d4d3de" }}>
                    <img src={process.env.PUBLIC_URL + '/images/ma_banner.svg'} alt="banner" style={{ width: '70%' }} />
                </Grid>
            </Grid>
            <Grid xs={12} sm={12} md={6} lg={6}>
                <Grid container justifyContent='center' alignContent='center' style={{ height: "100%"}}>
                    <img src={process.env.PUBLIC_URL + '/images/logo_en_cl.png'} alt="banner" style={{ width: '280px' }} />
                    <Grid container justifyContent='center' alignItems='center'>
                        <p style={{ color: "#53517c", textAlign: "center", fontSize: "20px" }} >Estamos trabajando para brindarte un mejor servicio.<br/>
                        Lamentamos los inconvenientes.</p>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

MaintenanceContainer.propTypes = {

};

export default MaintenanceContainer;